import { useMultiSelectInputContext } from '../contexts';
import { getListOptions } from '../utils/getListOptions';

export const useListMembershipOptions = () => {
  const { lists } = useMultiSelectInputContext();
  return getListOptions(lists);
};
